import React from 'react';
import { Link } from 'react-router-dom';
import { GridBackground } from '../GridBackground';
import { Spotlight } from '../ui/Spotlight';

const TerminosYCondiciones = () => {
  return (
    <div className="relative min-h-screen bg-black text-white overflow-hidden">
      <GridBackground />
      <Spotlight className="-top-40 left-0 md:-top-20 md:left-60" fill="white" />

      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center p-4">
        <div className="w-full max-w-4xl bg-neutral-900/80 backdrop-blur-md border border-neutral-700 rounded-2xl shadow-2xl p-8 mt-12 mb-8">
          <div className="mb-8 flex items-center justify-between">
            <Link to="/descargar-app" className="bebas-font text-2xl text-neutral-400 hover:text-neutral-300 transition-colors tracking-widest flex items-center gap-2">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
              VOLVER A APP
            </Link>
          </div>
          <h1 className="bebas-font text-5xl text-center tracking-wider mb-6 text-white">
            Términos y Condiciones de Uso
          </h1>
          <div className="space-y-6 text-neutral-400 leading-relaxed">
            <section>
              <h2 className="bebas-font text-3xl text-neutral-200 mb-2">I. Aceptación del Contrato</h2>
              <p>El acceso y uso de Gimnasio Energy atribuye la condición de "Usuario". Al registrarse, el usuario declara haber leído, entendido y aceptado estos términos en su totalidad.</p>
            </section>
            <section>
              <h2 className="bebas-font text-3xl text-neutral-200 mb-2">II. Capacidad Legal</h2>
              <p>De conformidad con el Código Civil Peruano, el usuario declara ser mayor de 18 años. En caso de menores de edad, se requiere la supervisión y autorización expresa de los padres o tutores legales.</p>
            </section>
            <section>
              <h2 className="bebas-font text-3xl text-neutral-200 mb-2">III. Descargo de Responsabilidad Médica (Excluyente de Responsabilidad)</h2>
              <h3 className="bebas-font text-2xl text-neutral-300 mt-4 mb-1">No es asesoría médica:</h3>
              <p>El contenido de la app (rutinas, cálculos de peso/talla) es informativo. No sustituye la consulta con un médico o nutricionista colegiado.</p>
              <h3 className="bebas-font text-2xl text-neutral-300 mt-4 mb-1">Asunción de riesgo:</h3>
              <p>El usuario reconoce que la actividad física conlleva riesgos. Gimnasio Energy no se hace responsable por lesiones, daños a la salud o accidentes derivados del uso de la aplicación.</p>
            </section>
            <section>
              <h2 className="bebas-font text-3xl text-neutral-200 mb-2">IV. Uso de la Cuenta y Fotos</h2>
              <p>El usuario es responsable de la veracidad de los datos (edad, peso, correo).</p>
              <h3 className="bebas-font text-2xl text-neutral-300 mt-4 mb-1">Contenido prohibido:</h3>
              <p>Queda prohibido subir fotos que vulneren derechos de terceros, sean obscenas o ilegales. Nos reservamos el derecho de eliminar cualquier contenido que infrinja estas normas.</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TerminosYCondiciones;
